export enum AppType {
    ANON,
    ADMIN,
    MANAGER,
    CLIENT,
    LAWYER,
}